<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="增加设备" name="first">
      <div class="addEquip_form">
        <el-form ref="form" :model="form" label-width="105px" class="demo-ruleForm">
          <el-form-item label="*选择生产单元">
            <el-select v-model="form.pond_id" placeholder="请选择生产单元" >
              <div v-for="pond in listPond" :key="pond.id">
                <el-option :label="pond.name" :value="pond.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*设备名称">
            <el-input v-model="form.equip_name" placeholder="自定义"></el-input>
          </el-form-item>
          <el-form-item label="*设备类型">
            <el-select v-model="form.equip_type" placeholder="请选择传感器类型" >
              <div v-for="(equipType,index) in listEquipType" :key="index">
                <el-option :label="equipType.type" :value="equipType.type"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*终端">
            <el-select v-model="form.equip_term_id" placeholder="请选择终端" >
              <div v-for="(term,index) in listTerm" :key="index">
                <el-option :label="term.name" :value="term.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*485地址">
            <el-input v-model="form.equip_addr" placeholder="范围：1-255"></el-input>
          </el-form-item>
          <el-form-item label="*第几路继电器">
            <el-input v-model="form.equip_road"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定增加</el-button>
            <el-button @click="Cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      form: {
        pond_id: '',
        equip_name: '',
        equip_type: '',
        equip_term_id: '',
        equip_addr: '',
        equip_road: ''
      },
      listPond: {},
      listEquipType: [],
      listTerm: {}
    }
  },
  methods: {
    onSubmit () {
      let formdata = new FormData()
      formdata.append('cell_id', this.form.pond_id)
      formdata.append('equip_type', this.form.equip_type)
      formdata.append('equip_name', this.form.equip_name)
      formdata.append('term_id', this.form.equip_term_id)
      formdata.append('addr', this.form.equip_addr)
      formdata.append('road', this.form.equip_road)
      this.axios.post(this.$store.state.ip + 'equipdef/addEquip', formdata, {headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}}).then(res => {
        // console.log(res)
        this.$message.success('设备添加成功')
        this.form = {}
      }).catch(err => {
        this.$message.error('设备添加失败')
        console.log(err)
      })
    },
    Cancel () {
      this.form = {}
    }
  },
  created () {
    // 获取当前用户的塘口信息
    this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
      {
        params: {'username': window.sessionStorage.getItem('username')},
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listPond = res.data.data.list
      // console.log(res.data.data.list)
    }).catch(err => {
      console.log(err)
    })
    // 获取所支持的设备类型
    this.axios.get(this.$store.state.ip + 'equipdef/showEquipType', {headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}}).then(res => {
      this.listEquipType = res.data.data
      // console.log(res.data.data)
    }).catch(err => {
      console.log(err)
    })
    // 获取 用户的所有终端
    this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
      {
        params: {'user_name': window.sessionStorage.getItem('username')},
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listTerm = res.data.data.list
      for (let i = 0; i < this.listTerm.length; i++) {
        this.listTerm[i].id = this.listTerm[i].id.toString()
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style scoped>
  .addEquip_form {
    width: 450px;
    margin-left: 20px;
    margin-top: 30px;
  }
  .el-input, .el-select {
    margin-left: 10px;
    width: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/addEquip.vue